exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".buyList[data-v-28d64522]{position:absolute;top:50%;left:0;width:90%;height:100px;margin-top:100px;margin-left:5%;height:0;z-index:1900}.buyList li[data-v-28d64522]{line-height:40px;animation:tohide 4s linear;opacity:0;position:absolute;bottom:0;left:0;text-align:center;width:100%}.buyList img[data-v-28d64522]{height:28px;vertical-align:middle;display:inline-block}.buyList span[data-v-28d64522]:first-child{font-size:22px;color:#ff4040;position:relative;font-weight:700;z-index:0;display:inline-block;vertical-align:middle}.buyList span[data-v-28d64522]:nth-child(2){display:inline-block;font-size:0;vertical-align:middle}.buyList span[data-v-28d64522]:before{content:attr(data-text);display:block;position:absolute;-webkit-text-stroke:4px #282828;z-index:-1}@keyframes tohide{0%{opacity:1}50%{opacity:.8}to{opacity:0;transform:translateY(-40px)}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-28d64522","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Modular/buyList.vue
// module id = 345
// module chunks = 0